import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-81">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-82">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-83" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="relative w-full max-w-2xl max-h-[80vh] bg-darknavy border border-white/10 rounded-2xl shadow-2xl overflow-hidden" data-id="element-84">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-white/10 sticky top-0 bg-darknavy z-10" data-id="element-85">
              <h2 className="text-xl font-heading text-cream" data-id="element-86">{title}</h2>
              <button onClick={onClose} className="text-warmgray hover:text-cream transition-colors p-1 rounded-lg hover:bg-white/5" aria-label="Cerrar" data-id="element-87">
                <X className="w-5 h-5" data-id="element-88" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-cream-dim text-sm leading-relaxed space-y-4 legal-content" data-id="element-89">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}